import {Outlet, Route, Routes} from 'react-router-dom'
import {Error500} from './components/Error500'
import {Error404} from './components/Error404'

const ErrorsLayout = () => {

  return (
    <div className='d-flex flex-column flex-column-fluid position-x-center bg-body'>
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <Outlet />
      </div>
    </div>
  )
}

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path='404' element={<Error404 />} />
      <Route path='500' element={<Error500 />} />
      <Route path='*' element={<Error404 />} />
    </Route>
  </Routes>
)

export {ErrorsPage}
